module.exports = __webpack_public_path__ + "img/gwdifferent.d5df0e82.jpg";